export default __webpack_public_path__ + "1d9cb226ba209afc56a8a94d8248784d.woff2";